import { render, staticRenderFns } from "./wf-dynamic-list-textarea-edit.vue?vue&type=template&id=c8dcae82&scoped=true&"
import script from "./wf-dynamic-list-textarea-edit.vue?vue&type=script&lang=ts&"
export * from "./wf-dynamic-list-textarea-edit.vue?vue&type=script&lang=ts&"
import style0 from "./wf-dynamic-list-textarea-edit.vue?vue&type=style&index=0&id=c8dcae82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8dcae82",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCheckbox,VMenu})
